/* Aureus Editorial desktop search, independent of sticky header state. */
(()=>{
  const desktop=window.matchMedia('(min-width:1200px)');
  function initSearch(){
    const toggle=document.querySelector('.shopify-section-header .ab-header-search-toggle');
    const dialog=document.getElementById('ab-header-search-dialog');
    const header=document.querySelector('.shopify-section-header');
    if(!toggle||!dialog||!header||toggle.dataset.abEditorialReady)return;
    const form=dialog.querySelector('.ab-hsearch__form');
    const input=dialog.querySelector('#ab-hsearch-input');
    const feedback=dialog.querySelector('.ab-hsearch__feedback');
    toggle.dataset.abEditorialReady='1';
    const open=()=>{
      if(!desktop.matches||dialog.open)return;
      header.classList.remove('shopify-section-header-hidden');
      dialog.showModal();
      requestAnimationFrame(()=>input?.focus({preventScroll:true}));
    };
    toggle.addEventListener('click',open);
    form?.addEventListener('submit',event=>{
      if(input&&!input.value.trim()){
        event.preventDefault();
        if(feedback)feedback.hidden=false;
        input.focus({preventScroll:true});
      }
    });
    input?.addEventListener('input',()=>{if(feedback)feedback.hidden=true});
    dialog.querySelector('[data-ab-hsearch-close]')?.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
    dialog.addEventListener('close',()=>{
      if(feedback)feedback.hidden=true;
      if(desktop.matches)toggle.focus({preventScroll:true});
    });
    desktop.addEventListener?.('change',()=>{
      if(!desktop.matches&&dialog.open)dialog.close();
    });
  }
  function init(){initSearch()}
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
